import chartPie from '@/components/charts/chartPie/index.vue';
import preloader from '@/components/preloader/index.vue';

import helpers from '@/mixins/helpers';

import Api from '@/utils/api';

export default {
  props: {
    qamode: {
      type: Object,
    },
    reportId: {
      type: Number,
      required: true,
    },
    projectName: {
      type: String,
      required: true,
    },
    langPair: {
      type: Array,
      required: true,
    },
  },
  mixins: [
    helpers.random_color,
  ],
  components: {
    chartPie,
    preloader,
  },
  data () {
    return {
      chartData: [],
      chartDataNew: [],
      activeTab: 0,
      load: true,
      statistics: {
        Data: {
          StatisticsByErrorCategories: [],
          EPAvarage: null,
          EPTotal: null,
        },
      },

      epMajorAverage: null,
      epMinorAverage: null,

      mainDataTable: {},
      errorCatHighchartsData: [],
      severityHighchartsData: [
        {
          name: 'Minor errors (m)',
          y: Number,
          color: '#85898C',
          totalError: Number,
          totalEP: Number,
        }, {
          name: 'Serious errors (s)',
          y: Number,
          color: '#B2B212',
          totalError: Number,
          totalEP: Number,
        }, {
          name: 'K-O errors (KO)',
          y: 0.5,
          color: 'red',
          totalError: 0,
          totalEP: 0,
        },
      ],
    };
  },
  created () {
    this.getAllStatistics();
  },
  methods: {
    showRowTable (name) {
      // console.log(name);
    },

    countAverTotalData () {
      let summAv = null;
      this.statistics.Data.StatisticsByErrorCategories.forEach((item, index) => {
        summAv += item.TotalEPCount;
      });
      this.statistics.Data.EPTotal = summAv;
      this.statistics.Data.EPAvarage = summAv / this.statistics.Data.StatisticsByErrorCategories.length;
    },

    getAllStatistics () {
      Api.reports
        .getStatistics(this.reportId)
        .then((data) => {
          if (data.status == 200) {
            this.statistics = data.data;
          }

          this.statistics.Data.StatisticsByErrorCategories.forEach((el) => {
            const color = this.generateColor();
            const data = {
              name: String,
              y: Number,
              totalError: Number,
              totalEP: Number,
              abbr: String,
            };

            el.color = color;
            data.name = el.ErrorCatName + ` (${el.ErrCatAbb})`;
            data.y = el.Percentage;
            data.color = el.color;
            data.totalError = el.TotalCount;
            data.totalEP = el.TotalEPCount;

            this.errorCatHighchartsData.push(data);
            this.countAverTotalData();

            this.epMajorAverage = this.epMajorAverage + el.EpMajor;
            this.epMinorAverage = this.epMinorAverage + el.EpMinor;
          });

          this.epMajorAverage = this.epMajorAverage / this.statistics.Data.StatisticsByErrorCategories.length;
          this.epMinorAverage = this.epMinorAverage / this.statistics.Data.StatisticsByErrorCategories.length;
          this.epMajorAverage = this.epMajorAverage.toFixed(1);
          this.epMinorAverage = this.epMinorAverage.toFixed(1);

          this.severityHighchartsData[0].y = this.statistics.Data.MinorPercentage;
          this.severityHighchartsData[0].totalError = this.statistics.Data.MinorCountTotal;
          this.severityHighchartsData[0].totalEP = this.statistics.Data.MinorEPCount;

          this.severityHighchartsData[1].y = this.statistics.Data.MajorPercentage;
          this.severityHighchartsData[1].totalError = this.statistics.Data.MajorCountTotal;
          this.severityHighchartsData[1].totalEP = this.statistics.Data.MajorEPCount;

          this.chartData = this.errorCatHighchartsData;
          this.chartDataNew = this.severityHighchartsData;

          if (data.data.Data) {
            this.load = false;
          }

          this.activeTab = 1;
        });
    },
  },
};
